import React from 'react';

import styled from '@emotion/styled';

import Page from '../../components/Page/Page';
import ContactForm from './ContactForm/ContactForm';
import ComponentHeader from '../../components/ComponentHeader/ComponentHeader';
// import MapArea from './MapArea/MapArea';

const Contact = () => {
  return (
    <Page title='CML | Contact'>
      <Container>
        <ComponentHeader align='left' text='Contact Us' description='Send us a message' />
        {/* <HeaderArea>
          <Header>Contact</Header>
          <Description>
            Committed to meeting your package delivery needs. Locate us on the
            map below
          </Description>
          <MapArea />
        </HeaderArea> */}
        <ContactForm />
      </Container>
    </Page>
  );
};

export default Contact;

const Container = styled.div`
  /* border: 2px solid red; */
  display: flex;
  gap: 64px;
  flex-direction: column;
  margin-top: 57px;
  margin-bottom: 101px;

  @media (max-width: 884px) {
    gap: 24px;
  }
`;

// const HeaderArea = styled.div`
//   display: flex;
//   gap: 28px;
//   flex-direction: column;
// `;

// const Header = styled.div`
//   font-weight: 700;
//   font-size: 48px;
//   line-height: 48px;
// `;

// const Description = styled.div``;
